import PersonaBlob from 'owa-persona/lib/store/schema/PersonaBlob';

/**
 * Creates a persona blob for a location
 */
export default function createNewPersonaBlob(): PersonaBlob {
    return {
        blobUrl: null,
        isPendingFetch: false,
        hasFetchFailed: false,
    };
}
